import Ajax from '../components/ajax'
import Modal from '../components/modal'
import { useForm } from 'react-hook-form'
import Search from '../components/search'
import Loading from '../components/loading'
import { useTranslation } from 'react-i18next'
import Pagination from '../components/pagination'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { employersAdd } from '../store/slices/mainSlices'
import { userLogin } from '../store/slices/mainSlices'

import editIcon from '../images/edit.png'
import deleteIcon from '../images/delete.png'

export default function Employers() {
  //Translate initialization
  const { t } = useTranslation()
  document.title = 'Employers | ' + t('name')

  //State manager initialization
  const dispatch = useDispatch()
  const [contentPerPage] = useState(10)
  const [editId, setEditId] = useState('')
  const [search, setSearch] = useState('')
  const [modalAdd, setModalAdd] = useState(false)
  const [pagination, setPagination] = useState('')
  const [modalEdit, setModalEdit] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [employersList, setEmployersList] = useState('')
  const allEmployers = useSelector(state => state.mainReducer.employers)

  //Modal for add new
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  //Modal for edit
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
    formState: { errors: errors2, isValid: isValid2 },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      editValues: {
        name: '',
        email: '',
        contactName: '',
        phone1: '',
        phone2: '',
        address: '',
        remark: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //Request for all Employers
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/employers/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        dispatch(employersAdd(data.data))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for add new Employer
  const onSubmitSave = data => {
    const ajaxUrl = 'manager/employers/add'
    const ajaxBody = {
      name: data.employersName,
      contact_name: data.employersContactName,
      phone1: data.employersPhoneOne,
      phone2: data.employersPhoneTwo,
      email: data.employersEmail,
      address: data.employersAddress,
      remark: data.employersRemark,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        reset()
        setModalAdd(false)
        const newEmployer = {
          id: data.data.id,
          name: data.data.name,
          contact_name: data.data.contact_name,
          phone1: data.data.phone1,
          phone2: data.data.phone2,
          email: data.data.email,
          address: data.data.address,
          remark: data.data.remark,
        }
        const newArrayEmployers = allEmployers.slice()
        newArrayEmployers.unshift(newEmployer)
        dispatch(employersAdd(newArrayEmployers))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  //Request for delete Employer
  const deleteEmployer = useCallback(
    event => {
      const ajaxUrl = 'manager/employers/delete'
      const ajaxBody = {
        id: event.target.dataset.value,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const newDeleteArray = allEmployers.slice()
          const indexDelete = newDeleteArray.indexOf(newDeleteArray.find(child => child.id === Number(event.target.dataset.value)))
          newDeleteArray.splice(indexDelete, 1)
          dispatch(employersAdd(newDeleteArray))
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [allEmployers, dispatch]
  )

  //Request for one Employer
  const oneEmployer = useCallback(
    event => {
      const ajaxUrl = 'manager/employers/getOne'
      const ajaxBody = { id: event.target.dataset.value }
      const method = 'post'
      setEditId(event.target.dataset.value)

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const resultArray = data.data
          const newEditArray = Object.keys(data.data)
          for (const key of newEditArray) {
            if (resultArray[key] === null) {
              resultArray[key] = ''
            }
          }
          setModalEdit(true)
          setValue2(
            'editValues',
            {
              name: resultArray.name,
              contactName: resultArray.contact_name,
              phone1: resultArray.phone1,
              phone2: resultArray.phone2,
              email: resultArray.email,
              address: resultArray.address,
              remark: resultArray.remark,
            },
            { shouldValidate: true }
          )
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [setValue2, dispatch]
  )

  //Request for edit Employer
  const editEmployer = data => {
    const ajaxUrl = 'manager/employers/update'
    const ajaxBody = {
      id: Number(editId),
      name: data.editValues.name,
      contact_name: data.editValues.contactName,
      phone1: data.editValues.phone1,
      phone2: data.editValues.phone2,
      email: data.editValues.email,
      address: data.editValues.address,
      remark: data.editValues.remark,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const newArrayEmployers = allEmployers.slice()
        const currentEditEmployer = newArrayEmployers.indexOf(newArrayEmployers.find(child => child.id === Number(editId)))
        newArrayEmployers[currentEditEmployer] = ajaxBody
        dispatch(employersAdd(newArrayEmployers))
        setModalEdit(false)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  //Table list for HTML
  useEffect(() => {
    if (allEmployers) {
      const lastPageIndex = currentPage * contentPerPage
      const firstPageIndex = lastPageIndex - contentPerPage
      const currentMyPage = allEmployers
        .filter(element => element.name.toLowerCase().includes(search.toLowerCase()))
        .slice(firstPageIndex, lastPageIndex)
      if (currentMyPage.length === 0) {
        setEmployersList(<p className='nothingFound'>Nothing found</p>)
      } else {
        setEmployersList(
          Object.values(currentMyPage).map(child => {
            return (
              <div className='item' key={child.id}>
                <p title={child.name}>{child.name}</p>
                <p title={child.contact_name}>{child.contact_name}</p>
                <p title={child.phone1}>{child.phone1}</p>
                <p title={child.phone2}>{child.phone2}</p>
                <p title={child.email}>{child.email}</p>
                <p title={child.address}>{child.address}</p>
                <p title={child.remark}>{child.remark}</p>
                <div className='itemButtons'>
                  <button data-value={child.id} onClick={event => oneEmployer(event)}>
                    <img src={editIcon} alt='edit icon' data-value={child.id} />
                  </button>
                  <button data-value={child.id} onClick={event => deleteEmployer(event)}>
                    <img src={deleteIcon} alt='delete icon' data-value={child.id} />
                  </button>
                </div>
              </div>
            )
          })
        )
        setPagination(
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            search={search}
            allEmployers={allEmployers}
            contentPerPage={contentPerPage}
          />
        )
      }
    } else {
      setEmployersList(<Loading />)
      setPagination(null)
    }
  }, [allEmployers, search, currentPage, contentPerPage, deleteEmployer, oneEmployer])

  return (
    <section className='employers'>
      <div className='addNew'>
        <h2>Employers</h2>
        <Search search={search} setSearch={setSearch} setCurrentPage={setCurrentPage} />
        <button onClick={() => setModalAdd(true)} value='addNew'>
          Add
        </button>
      </div>
      <div className='table'>
        <div className='item title'>
          <h2>Name</h2>
          <h2>Contact name</h2>
          <h2>Phone 1</h2>
          <h2>Phone 2</h2>
          <h2>Email</h2>
          <h2>Address</h2>
          <h2>Remark</h2>
          <div className='itemButtons'></div>
        </div>
        {employersList}
        <Modal active={modalAdd} setActive={setModalAdd}>
          <h2>Employers info</h2>
          <form onSubmit={handleSubmit(onSubmitSave)} autoComplete='off'>
            <label>
              <p>
                Name <span className='requiredInput'>*</span>
              </p>
              <input
                {...register('employersName', {
                  required: 'This field is required',
                  minLength: {
                    value: 3,
                    message: 'Min length 3',
                  },
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersName && errors.employersName.message}</span>
            <label>
              Contact name
              <input
                {...register('employersContactName', {
                  minLength: {
                    value: 3,
                    message: 'Min length 3',
                  },
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersContactName && errors.employersContactName.message}</span>
            <label>
              Phone 1
              <input
                type='number'
                {...register('employersPhoneOne', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersPhoneOne && errors.employersPhoneOne.message}</span>
            <label>
              Phone 2
              <input
                type='number'
                {...register('employersPhoneTwo', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersPhoneTwo && errors.employersPhoneTwo.message}</span>
            <label>
              <p>
                Email <span className='requiredInput'>*</span>
              </p>
              <input
                {...register('employersEmail', {
                  required: 'This field is required',
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'invalid email address',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersEmail && errors.employersEmail.message}</span>
            <label>
              Address
              <input
                {...register('employersAddress', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersAddress && errors.employersAddress.message}</span>
            <label>
              Remark
              <textarea
                {...register('employersRemark', {
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>{errors.employersRemark && errors.employersRemark.message}</span>
            <div className='buttons'>
              <input type='submit' className='sendButton' value='Save' disabled={!isValid} />
              <span className='sendButton' onClick={() => setModalAdd(false)}>
                Cancel
              </span>
            </div>
          </form>
        </Modal>
        <Modal active={modalEdit} setActive={setModalEdit}>
          <h2>Employers info</h2>
          <form onSubmit={handleSubmit2(editEmployer)} autoComplete='off'>
            <label>
              <p>
                Name <span className='requiredInput'>*</span>
              </p>
              <input
                {...register2('editValues.name', {
                  required: 'This field is required',
                  minLength: {
                    value: 3,
                    message: 'Min length 3',
                  },
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('name') ? errors2.editValues.name.message : null}
            </span>
            <label>
              Contact name
              <input
                {...register2('editValues.contactName', {
                  minLength: {
                    value: 3,
                    message: 'Min length 3',
                  },
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('contactName')
                ? errors2.editValues.contactName.message
                : null}
            </span>
            <label>
              Phone 1
              <input
                type='number'
                {...register2('editValues.phone1', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('phone1') ? errors2.editValues.phone1.message : null}
            </span>
            <label>
              Phone 2
              <input
                type='number'
                {...register2('editValues.phone2', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('phone2') ? errors2.editValues.phone2.message : null}
            </span>
            <label>
              <p>
                Email <span className='requiredInput'>*</span>
              </p>
              <input
                {...register2('editValues.email', {
                  required: 'This field is required',
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'invalid email address',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('email') ? errors2.editValues.email.message : null}
            </span>
            <label>
              Address
              <input
                {...register2('editValues.address', {
                  minLength: {
                    value: 6,
                    message: 'Min length 6',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Max length 100',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('address') ? errors2.editValues.address.message : null}
            </span>
            <label>
              Remark
              <textarea
                {...register2('editValues.remark', {
                  maxLength: {
                    value: 50,
                    message: 'Max length 50',
                  },
                })}
              />
            </label>
            <span className='errorResponse'>
              {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('remark') ? errors2.editValues.remark.message : null}
            </span>
            <div className='buttons'>
              <input type='submit' className='sendButton' value='Save' disabled={!isValid2} />
              <span className='sendButton' onClick={() => setModalEdit(false)}>
                Cancel
              </span>
            </div>
          </form>
        </Modal>
      </div>
      {pagination}
    </section>
  )
}
